import Stack from 'atoms/Layout/Stack/Stack';
import { cssVar } from 'src/app/styles/helper';
import styled from 'styled-components';

export const BadgeModernStack = styled(Stack)`
  box-shadow: ${cssVar('shadow-xs')};
`;
